import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Entry = r => require.ensure([], () => r(require('@/views/home/home')), 'rule');
const Server = r => require.ensure([], () => r(require('@/views/home/server')), 'rule');
const Bind = r => require.ensure([], () => r(require('@/views/home/bind')), 'rule');
const Sign = r => require.ensure([], () => r(require('@/views/home/sign')), 'rule');
const Unit = r => require.ensure([], () => r(require('@/views/home/unit')), 'rule');
const CheckSign = r => require.ensure([], () => r(require('@/views/sign/checkSign')), 'rule');
const MySign = r => require.ensure([], () => r(require('@/views/sign/mySign')), 'rule');
const LaborDtl = r => require.ensure([], () => r(require('@/views/labor/laborDtl')), 'rule');
const LaborList = r => require.ensure([], () => r(require('@/views/labor/laborList')), 'rule');
const Rule = r => require.ensure([], () => r(require('@/views/rule')), 'rule');
const Linkjudge = r => require.ensure([], () => r(require('@/views/Linkjudge')), 'rule');
const MassedLearning = r => require.ensure([], () => r(require('@/views/massedLearning')), 'rule');
const LearningSearch = r => require.ensure([], () => r(require('@/views/massedLearning/LearningSearch')), 'rule');
const PublishLearn = r => require.ensure([], () => r(require('@/views/massedLearning/publishLearn')), 'rule');
const detailLearn = r => require.ensure([], () => r(require('@/views/massedLearning/detailLearn')), 'rule');
const manageLearn = r => require.ensure([], () => r(require('@/views/massedLearning/manageLearn')), 'rule');
const correctPersion = r => require.ensure([], () => r(require('@/views/massedLearning/correctPersion')), 'rule');
const addCorrectPersion = r => require.ensure([], () => r(require('@/views/massedLearning/addCorrectPersion')), 'rule');
const editorPage = r => require.ensure([], () => r(require('@/views/massedLearning/editorPage')), 'rule');
const accessoryList = r => require.ensure([], () => r(require('@/views/massedLearning/accessoryList')), 'rule');
const signDeskpage = r => require.ensure([], () => r(require('@/views/massedLearning/signDeskpage')), 'rule');
const joincheckSign = r => require.ensure([], () => r(require('@/views/massedLearning/checkSign')), 'rule');
const Temporary = r => require.ensure([], () => r(require('@/views/massedLearning/Temporary')), 'rule');
const checkinfo = r => require.ensure([], () => r(require('@/views/massedLearning/checkinfo')), 'rule');
const previewVideo = r => require.ensure([], () => r(require('@/views/massedLearning/previewVideo')), 'rule');
const setarea = r => require.ensure([], () => r(require('@/views/massedLearning/setarea')), 'rule');
// 矫正人员集中学习
const cMassedLearning = r => require.ensure([], () => r(require('@/views/correctML')), 'rule');
const cdetailInfo = r => require.ensure([], () => r(require('@/views/correctML/cdetailInfo')), 'rule');
let router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Bind',
            component: Bind,
        },
        {
            path: '/rule',
            name: 'Rule',
            component: Rule,
        },
        {
            path: '/Linkjudge',
            name: 'Linkjudge',
            component: Linkjudge,
        },
        {
            path: '/home',
            name: 'Entry',
            component: Entry,
        },
        {
            path: '/server',
            name: 'Server',
            component: Server,
        },
        {
            path: '/sign',
            name: 'Sign',
            component: Sign,
        },
        {
            path: '/unit',
            name: 'Unit',
            component: Unit,
        },

        {
            path: '/checksign',
            name: 'CheckSign',
            component: CheckSign,
        },
        {
            path: '/mySign',
            name: 'MySign',
            component: MySign,
        },
        {
            path: '/labordtl',
            name: 'LaborDtl',
            component: LaborDtl,
        },
        {
            path: '/laborlist',
            name: 'LaborList',
            component: LaborList,
        },
        // 集中学习
        {
            path: '/massedLearning',
            name: 'massedLearning',
            component: MassedLearning,
        },
        {
            path: '/LearningSearch',
            name: 'LearningSearch',
            component: LearningSearch,
        },
        {
            path: '/PublishLearn',
            name: 'PublishLearn',
            component: PublishLearn,
        },
        {
            path: '/detailLearn',
            name: 'detailLearn',
            component: detailLearn,
        },
        {
            path: '/manageLearn',
            name: 'manageLearn',
            component: manageLearn,
        },
        {
            path: '/correctPersion',
            name: 'correctPersion',
            component: correctPersion,
        },
        {
            path: '/addCorrectPersion',
            name: 'addCorrectPersion',
            component: addCorrectPersion,
        },
        {
            path: '/editorPage',
            name: 'editorPage',
            component: editorPage,
        },
        {
            path: '/accessoryList',
            name: 'accessoryList',
            component: accessoryList,
        },
        {
            path: '/signDeskpage',
            name: 'signDeskpage',
            component: signDeskpage,
        },
        {
            path: '/joincheckSign',
            name: 'joincheckSign',
            component: joincheckSign,
        },
        {
            path: '/Temporary',
            name: 'Temporary',
            component: Temporary,
        },
        {
            path: '/checkinfo',
            name: 'checkinfo',
            component: checkinfo,
        },
        {
            path: '/previewVideo',
            name: 'previewVideo',
            component: previewVideo,
        },
        {
            path: '/cMassedLearning',
            name: 'cMassedLearning',
            component: cMassedLearning,
        },
        {
            path: '/cdetailInfo',
            name: 'cdetailInfo',
            component: cdetailInfo,
        },
        {
            path: '/setarea',
            name: 'setarea',
            component: setarea,
        },
        // setarea addCorrectPersion accessoryList
    ]
})

router.beforeEach((to, from, next) => {
    if (to.path == '/' && from.path == '/home') {
        window.close()
    } else {
        next()
    }
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js